import { z } from 'zod'

export const ConfigurationSupportLlmZod = z.object({
  model: z
    .string()
    .regex(/^gemini-[\w.-]+$/)
    .nullish(),
  temperature: z.number().min(0).max(2).nullish(),
  maxOutputTokens: z.number().int().min(64).max(8192).nullish(),
  thinkingBudget: z.number().int().min(0).max(8192).nullish(),
  titlePrompt: z.string().nullish(),
  summaryPrompt: z.string().nullish(),
})
export type ConfigurationSupportLlm = z.infer<typeof ConfigurationSupportLlmZod>
